import { createAction } from 'redux-actions';

export const SET_LANGUAGE_ACTION = 'SET_LANGUAGE_ACTION';

export const setLanguageAction = createAction(SET_LANGUAGE_ACTION);
